import React, { useState, useRef, useEffect } from "react";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  continue_timer,
  showTimer,
  timer_active,
  updateRedux,
} from "../../redux/commonReducer";

const Timer = memo(({ disabled, timer, setTimer, setIntervalId, intervalId }) => {
  const dispatch = useDispatch();

  const time = useSelector(showTimer);
  const continueTimer = useSelector(continue_timer);
  const timerActive = useSelector(timer_active)
  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  const Ref = useRef(null);

  // The state for our timer

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor(((total / 1000) * 60 * 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimerLocal = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);

    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the begining of the variable
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
          ":" +
          (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
    // console.log(total)
    if(total == 0){
      console.log("total")
      if(intervalId){
        clearInterval(intervalId);
      } 
      dispatch(updateRedux({ key: "showTimer", value: false }));
      dispatch(updateRedux({ key: "timer_active", value: false }));
    }
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    // setTimer("00:02:00");

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current != null) {
      clearInterval(Ref.current);
    }
    let id;
    if (time) {
      id = setInterval(() => {
        startTimerLocal(e);
      }, 1000);
      setIntervalId(id)
    }
    setTimeout(() =>{
      setTimer("00:00:00");
      if(id){
        clearInterval(id);
      } 
    },[185000])
    Ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 180);
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only
  useEffect(() => {
    if(timerActive == true ) {
      clearTimer(getDeadTime());
      dispatch(updateRedux({ key: "timer_active", value: false }));
    } 
  }, [timerActive]);

  // // Another way to call the clearTimer() to start
  // // the countdown is via action event from the
  // // button first we create function to be called
  // // by the button
  // const onClickReset = () => {
  //   clearTimer(getDeadTime());
  // };
  return <p disabled={disabled}>{timer}</p>;
});

export default Timer;
